import mixpanel from 'mixpanel-browser';
import { useEffect } from 'react';

import { NewRelic } from '../hooks/useNewRelic';

const hardCodedLocale = 'en';
export function useDetectBrowserTranslation() {
  useEffect(() => {
    const detectTranslation = () => {
      const lang = document.documentElement.lang;
      if (lang !== hardCodedLocale) {
        mixpanel.register({
          browserTranslation: lang,
        });
        NewRelic()?.setCustomAttribute('browserTranslation', lang);
      }
    };

    // Initial check
    detectTranslation();

    // Observe changes to the html element's attributes
    const observer = new MutationObserver(detectTranslation);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang'],
      childList: false,
      characterData: false,
    });

    const title = document.getElementsByTagName('title')[0];
    const detectTranslationMicrosoftEdge = () => {
      if (title?.hasAttribute('_msttexthash')) {
        mixpanel.register({
          browserTranslation: "idk; it's microsoft edge",
        });
        NewRelic()?.setCustomAttribute('browserTranslation', "idk; it's microsoft edge");
      }
    };
    detectTranslationMicrosoftEdge();

    const observer2 = new MutationObserver(detectTranslationMicrosoftEdge);
    observer2.observe(title, {
      attributes: true,
      attributeFilter: ['_msttexthash'],
      childList: false,
      characterData: false,
    });

    return () => {
      observer.disconnect();
      observer2.disconnect();
    };
  }, []);
}
